import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'category',
})
export class CategoryPipe implements PipeTransform {
  transform(array: any[], args: any): any {
    console.log(args);

    if (!args.campaign_id && args.lines_id.length === 0) {
      return array;
    }
    if (!args.campaign_id && args.lines_id.length !== 0) {
      return array.filter((product) => {
        return args.lines_id.includes(product.line_id);
      });
    }
    if (args.campaign_id != 0 && args.lines_id.length == 0) {
      return array.filter((product) => {
        return product.category_id == +args.campaign_id;
      });
    }
    if (args.campaign_id != 0 && args.lines_id.length !== 0) {
      return array.filter((product) => {
        return (
          args.lines_id.includes(product.line_id) &&
          product.category_id == +args.campaign_id
        );
      });
    }
  }
}
